var render = function render(){var _vm=this,_c=_vm._self._c;return _c('add',{attrs:{"action":'edit',"mealItem":_vm.item}})
}
var staticRenderFns = []

export { render, staticRenderFns }